import { Component, OnInit, Input } from '@angular/core';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

@Component({
	selector: 'ras-page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.sass']
})
export class PageComponent implements OnInit {

	public show_map: boolean = false
	public show_menu: boolean = false

	@Input() tag: string|null = null
	@Input() headingHtml: string = "<h1><b>Peace</b> of mind high-security self-storage</h1>"
	@Input() show_heading: boolean = false
	@Input() thin_footer: boolean = false
	@Input() menu: boolean = true

	@Input() set mapUrl(value: string) {this._mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(value) }
	public _mapUrl: SafeResourceUrl = null

	@Input() description: string = "Storage units for all your self-storage needs"

	constructor(private sanitizer:DomSanitizer) { }

	ngOnInit() {
	}

}
